const products = [
  {
    name: 'Jordan 1 Retro',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20photograph%20of%20a%20single%20pristine%20white%20and%20university%20red%20retro%20basketball%20sneaker%20placed%20on%20a%20minimalist%20light%20warm%20gray%20studio%20surface%20with%20soft%20even%20lighting%20from%20a%20large%20softbox%20clean%20commercial%20product%20photography%20style%20isolated%20on%20neutral%20background&width=600&height=600&seq=prod-shoe-v2&orientation=squarish',
  },
  {
    name: 'Travis Scott Hoodie',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20photograph%20of%20a%20single%20earthy%20brown%20oversized%20cotton%20hoodie%20sweater%20folded%20neatly%20on%20a%20minimalist%20light%20warm%20gray%20studio%20surface%20with%20soft%20even%20lighting%20from%20a%20large%20softbox%20clean%20commercial%20product%20photography%20style&width=600&height=600&seq=prod-hoodie-v2&orientation=squarish',
  },
  {
    name: 'Luxury Tote',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20photograph%20of%20a%20single%20elegant%20cream%20canvas%20and%20tan%20leather%20tote%20bag%20standing%20upright%20on%20a%20minimalist%20light%20warm%20gray%20studio%20surface%20with%20soft%20even%20lighting%20from%20a%20large%20softbox%20clean%20commercial%20product%20photography%20style&width=600&height=600&seq=prod-bag-v2&orientation=squarish',
  },
];

export default function ProductGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-16">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-5xl md:text-6xl lg:text-[64px] leading-[0.95] font-light text-foreground-950">Curated</h2>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-[64px] leading-[0.95] font-bold text-foreground-950">Products</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {products.map((product) => (
            <a key={product.name} href={product.url} target="_blank" rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:border-foreground-300">
              <div className="aspect-square bg-background-50 flex items-center justify-center p-6">
                <img src={product.imageUrl} alt={product.name} className="w-full h-full object-contain object-center" />
              </div>
              <div className="px-5 pb-5">
                <h3 className="font-heading text-xl md:text-2xl text-foreground-900 font-medium">{product.name}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}